'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var sanitizeHost = function sanitizeHost(host) {
    return host.trim().replace(/\/*$/, '');
};

var sanitizeUrl = function sanitizeUrl(url) {
    return url.trim().replace(/^\/*/, '').replace(/\/$/, '');
};

exports.default = function (config) {
    var host = sanitizeHost(config.host);
    var withHost = function withHost(url) {
        return host + '/' + sanitizeUrl(url);
    };

    return {
        article: function article(id) {
            var transformation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            return withHost(config.article.replace('{{ID}}', id).replace('{{TRANSFORMATION}}', transformation));
        },
        theme: function theme() {
            return withHost(config.theme);
        }
    };
};
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/iris-urls/lib/cjs/index.js
 ** module id = 545
 ** module chunks = 1
 **/